import TermsAndConditionLayout from "./TermsAndConditionLayout";
import { termsConditionsData } from "./termsConditions.data";

export const TermsAndConditionTemplate = () => {
  
  return (
    <>
      <section className="contact-form bg-white">
        <div className="container mx-auto px-4  mt-6"> 
          {termsConditionsData.map((section, idx) => (
            <div className="mb-8" key={idx}>
              <TermsAndConditionLayout
                heading={section.heading}
                content={section.content}
                className="mb-1"
              />
            </div>
          ))} 
        </div>
      </section>
    </>
  );
};
export default TermsAndConditionTemplate;
